import { SessionStorage } from './storage.service';

export enum LocalStoreKey {
  Token = 't',
  TokenActivated = 'ta',
  TokenVerified = 'tv',
  ClientCode = 'cc' // used only by CookieStore and not SessionStore
}

export function getActivationToken(): string {
  return SessionStorage.getItem(LocalStoreKey.Token) || '';
}

export function setActivationToken(value: string, removeVerifiedAndActivated: boolean = false): void {
  const trimmedValue = value.trim();
  if (trimmedValue.length === 0) {
    removeActivationToken();
  } else {
    SessionStorage.setItem(LocalStoreKey.Token, trimmedValue);
  }

  if (removeVerifiedAndActivated === true) {
    removeActivationTokenActivated();
    removeActivationTokenVerified();
  }
}

export function removeActivationToken(): void {
  SessionStorage.removeItem(LocalStoreKey.Token);
}

export function getActivationTokenVerified(): boolean {
  return SessionStorage.getItem(LocalStoreKey.TokenVerified) === '1';
}

export function setActivationTokenVerified(value: boolean): void {
  SessionStorage.setItem(LocalStoreKey.TokenVerified, value === true ? '1' : '0');
}

export function removeActivationTokenVerified(): void {
  SessionStorage.removeItem(LocalStoreKey.TokenVerified);
}

export function getActivationTokenActivated(): boolean {
  return SessionStorage.getItem(LocalStoreKey.TokenActivated) === '1';
}

export function setActivationTokenActivated(value: boolean): void {
  SessionStorage.setItem(LocalStoreKey.TokenActivated, value === true ? '1' : '0');
}

export function removeActivationTokenActivated(): void {
  SessionStorage.removeItem(LocalStoreKey.TokenActivated);
}
